<!-- Progress Bar -->
<div class="sticky-top bg-white py-2 border-bottom p-5" style="z-index: 999; height: 50px;">
  <div class="d-flex justify-content-between align-items-center mb-1">
    <small class="text-muted fw-500">Form Completion</small>
    <small class="fw-semibold text-primary">{{ formProgress }}%</small>
  </div>
  <div class="progress-bar-container">
    <div class="progress-fill" [style.width.%]="formProgress"></div>
  </div>
</div>

<div class="form-wrapperX mt-2">
  <!-- Success Toast -->
  <!-- @if (submitSuccess) {
    <div class="success-toast alert alert-success d-flex align-items-center gap-3 shadow-lg" role="alert">
      <i class="bi bi-check-circle-fill fs-4"></i>
      <div>
        <strong>Application Submitted Successfully!</strong><br>
        <small>Your application has been received. You will be notified via email.</small>
      </div>
      <button type="button" class="btn-close ms-auto" (click)="submitSuccess = false"></button>
    </div>
  } -->

  <div class="container-xl">
    <!-- Form Header -->
    <!-- <div class="form-card mb-3 mt-1">
      <div class="form-header">
        <div class="school-logo">
          <i class="bi bi-mortarboard-fill"></i>
        </div>
        <h1>Student Admission Application Form</h1>
        <p>Academic Year 2025-2026 &nbsp;|&nbsp; Please fill all required fields carefully</p>
      </div>
      <div class="sticky-top bg-white py-2 border-bottom p-5" style="z-index: 999; height: 50px;">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <small class="text-muted fw-500">Form Completion</small>
          <small class="fw-semibold text-primary">{{ formProgress }}%</small>
        </div>
        <div class="progress-bar-container">
          <div class="progress-fill" [style.width.%]="formProgress"></div>
        </div>
      </div>
    </div> -->

    <div class="w-100 d-flex align-items-center justify-content-between" style="height: 80px;">
      <!-- Profile Photo -->
      <div class="col-4 d-flex align-items-center gap-4 mb-2">
        <div class="photo-preview">
          @if (personal.profile_photo) {
            <img [src]="personal.profile_photo" alt="Profile">
          }
        </div>
        <div>
          <label class="btn btn-outline-primary btn-sm" for="photoInput">
            <i class="bi bi-camera-fill me-1"></i> Upload Photo
          </label>
          <input type="file" id="photoInput" class="d-none" accept="image/*" (change)="onprofile_photo($event)">
          <div class="form-text">Max Size 40KB</div>
        </div>
      </div>
      <div class="col-8 col-lg-4 my-2" *ngIf="!editID">
        <div class="input-group">
          <input type="text" class="form-control py-2" placeholder="Search Application"
          aria-label="Institute ID" aria-describedby="button-addon2" [(ngModel)]="searchTerm"
          (keyup.enter)="onSearchChange()">
          <button class="btn btn-primary" type="button" id="button-addon2" (click)="onSearchChange()">Search</button>
        </div>
      </div>
    </div>

    <form #appForm="ngForm" (ngSubmit)="onSubmit(appForm)" novalidate>

      <!-- ===================== A. PERSONAL DETAILS ===================== -->
      <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-person-fill"></i>
          A. Personal Details
          <span class="ms-auto badge-section">Required</span>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6 col-lg-4"><b>App. Code</b>: {{personal.app_code}}</div>
            <div class="col-md-6 col-lg-4"><b>Adm. Code</b>: {{personal.adm_code}}</div>
            <div class="col-md-6 col-lg-4 d-flex align-items-center gap-2">
              <span><b>Login Password</b>: </span>
              <input type="password" name="passWord"
                style="border: 1px solid #cccccc; border-radius: 8px; height: 34px; width: 60%; padding: 5px 10px;"
                [(ngModel)]="personal.passWord" placeholder="Login Password">
            </div>

            <!-- Student Name -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Student Full Name <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="studentName"
                [(ngModel)]="personal.studentName"
                #studentName="ngModel"
                required
                minlength="3"
                maxlength="100"
                placeholder="As per birth certificate"
                [class.is-invalid]="(studentName.invalid && studentName.touched) || (submitted && studentName.invalid)"
                [class.is-valid]="studentName.valid && studentName.touched"
              >
              @if ((studentName.invalid && studentName.touched) || (submitted && studentName.invalid)) {
                <div class="invalid-feedback">
                  @if (studentName.errors?.['required']) { Full name is required. }
                  @if (studentName.errors?.['minlength']) { Name must be at least 3 characters. }
                </div>
              }
            </div>

            <!-- Gender -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Gender <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="gender"
                [(ngModel)]="personal.gender"
                #gender="ngModel"
                required
                [class.is-invalid]="(gender.invalid && gender.touched) || (submitted && gender.invalid)"
                [class.is-valid]="gender.valid && gender.touched"
              >
                <option value="">-- Select Gender --</option>
                @for (g of genderOptions; track g) {
                  <option [value]="g">{{ g }}</option>
                }
              </select>
              @if ((gender.invalid && gender.touched) || (submitted && gender.invalid)) {
                <div class="invalid-feedback">Please select gender.</div>
              }
            </div>

            <!-- Date of Birth -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Date of Birth <span class="required-star">*</span></label>
              <input
                type="date"
                class="form-control"
                name="dateOfBirth"
                [(ngModel)]="personal.dateOfBirth"
                #dateOfBirth="ngModel"
                required
                [max]="getMaxDOB()"
                [min]="getMinDOB()"
                [class.is-invalid]="(dateOfBirth.invalid && dateOfBirth.touched) || (submitted && dateOfBirth.invalid)"
                [class.is-valid]="dateOfBirth.valid && dateOfBirth.touched"
              >
              @if ((dateOfBirth.invalid && dateOfBirth.touched) || (submitted && dateOfBirth.invalid)) {
                <div class="invalid-feedback">Valid date of birth is required.</div>
              }
            </div>

            <!-- Category -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Category <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="category"
                [(ngModel)]="personal.category"
                #category="ngModel"
                required
                [class.is-invalid]="(category.invalid && category.touched) || (submitted && category.invalid)"
                [class.is-valid]="category.valid && category.touched"
              >
                <option value="">-- Select Category --</option>
                @for (cat of categoryOptions; track cat) {
                  <option [value]="cat.code">{{ cat.code + ' - ' + cat.name }}</option>
                }
              </select>
              @if ((category.invalid && category.touched) || (submitted && category.invalid)) {
                <div class="invalid-feedback">Please select category.</div>
              }
            </div>

            <!-- Religion -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Religion</label>
              <select class="form-select" name="religion" [(ngModel)]="personal.religion">
                <option value="">-- Select Religion --</option>
                @for (rel of religionOptions; track rel) {
                  <option [value]="rel.code">{{ rel.name }}</option>
                }
              </select>
            </div>

            <!-- Nationality -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Nationality <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="nationality"
                [(ngModel)]="personal.nationality"
                #nationality="ngModel"
                required
                maxlength="50"
                placeholder="e.g. Indian"
                [class.is-invalid]="(nationality.invalid && nationality.touched) || (submitted && nationality.invalid)"
                [class.is-valid]="nationality.valid && nationality.touched"
              >
              @if ((nationality.invalid && nationality.touched) || (submitted && nationality.invalid)) {
                <div class="invalid-feedback">Nationality is required.</div>
              }
            </div>

            <!-- Aadhaar Number -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Aadhaar Number <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="aadhaarNumber"
                [(ngModel)]="personal.aadhaarNumber"
                #aadhaarNumber="ngModel"
                required
                pattern="^\d{12}$"
                maxlength="12"
                placeholder="12-digit Aadhaar number"
                [class.is-invalid]="(aadhaarNumber.invalid && aadhaarNumber.touched) || (submitted && aadhaarNumber.invalid)"
                [class.is-valid]="aadhaarNumber.valid && aadhaarNumber.touched"
              >
              @if ((aadhaarNumber.invalid && aadhaarNumber.touched) || (submitted && aadhaarNumber.invalid)) {
                <div class="invalid-feedback">
                  @if (aadhaarNumber.errors?.['required']) { Aadhaar number is required. }
                  @if (aadhaarNumber.errors?.['pattern']) { Must be exactly 12 digits. }
                </div>
              }
            </div>

            <!-- Blood Group -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Blood Group</label>
              <select class="form-select" name="bloodGroup" [(ngModel)]="additional.bloodGroup">
                <option value="">-- Select Blood Group --</option>
                @for (bg of bloodGroupOptions; track bg) {
                  <option [value]="bg">{{ bg }}</option>
                }
              </select>
            </div>

          </div>
        </div>
      </div>

      <!-- ===================== B. PARENT DETAILS ===================== -->
      <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-people-fill"></i>
          B. Parent / Guardian Details
        </div>
        <div class="card-body">

          <!-- Father -->
          <p class="sub-section-title"><i class="bi bi-person-badge"></i> Father's Details</p>
          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Father's Full Name <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="fatherName"
                [(ngModel)]="father.name"
                #fatherName="ngModel"
                required
                minlength="3"
                maxlength="100"
                placeholder="Father's full name"
                [class.is-invalid]="(fatherName.invalid && fatherName.touched) || (submitted && fatherName.invalid)"
                [class.is-valid]="fatherName.valid && fatherName.touched"
              >
              @if ((fatherName.invalid && fatherName.touched) || (submitted && fatherName.invalid)) {
                <div class="invalid-feedback">Father's name is required (min 3 characters).</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Qualification</label>
              <input type="text" class="form-control" name="fatherQualification" [(ngModel)]="father.qualification" maxlength="80" placeholder="e.g. Graduate">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Occupation</label>
              <input type="text" class="form-control" name="fatherOccupation" [(ngModel)]="father.occupation" maxlength="80" placeholder="e.g. Engineer">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Mobile Number <span class="required-star">*</span></label>
              <div class="input-group">
                <span class="input-group-text bg-light">+91</span>
                <input
                  type="tel"
                  class="form-control"
                  name="fatherMobile"
                  [(ngModel)]="father.mobile"
                  #fatherMobile="ngModel"
                  required
                  pattern="^[6-9]\d{9}$"
                  maxlength="10"
                  placeholder="10-digit mobile"
                  [class.is-invalid]="(fatherMobile.invalid && fatherMobile.touched) || (submitted && fatherMobile.invalid)"
                  [class.is-valid]="fatherMobile.valid && fatherMobile.touched"
                >
              </div>
              @if ((fatherMobile.invalid && fatherMobile.touched) || (submitted && fatherMobile.invalid)) {
                <div class="invalid-feedback d-block">
                  @if (fatherMobile.errors?.['required']) { Mobile is required. }
                  @if (fatherMobile.errors?.['pattern']) { Enter a valid 10-digit mobile number. }
                </div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Email Address</label>
              <input
                type="email"
                class="form-control"
                name="fatherEmail"
                [(ngModel)]="father.email"
                #fatherEmail="ngModel"
                email
                maxlength="100"
                placeholder="father@email.com"
                [class.is-invalid]="fatherEmail.invalid && fatherEmail.touched"
                [class.is-valid]="fatherEmail.valid && fatherEmail.touched && father.email !== ''"
              >
              @if (fatherEmail.invalid && fatherEmail.touched) {
                <div class="invalid-feedback">Enter a valid email address.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Annual Income (₹)</label>
              <input type="number" class="form-control" name="fatherIncome" [(ngModel)]="father.annualIncome" min="0" placeholder="e.g. 500000">
            </div>
          </div>

          <!-- Mother -->
          <p class="sub-section-title"><i class="bi bi-person-heart"></i> Mother's Details</p>
          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Mother's Full Name <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="motherName"
                [(ngModel)]="mother.name"
                #motherName="ngModel"
                required
                minlength="3"
                maxlength="100"
                placeholder="Mother's full name"
                [class.is-invalid]="(motherName.invalid && motherName.touched) || (submitted && motherName.invalid)"
                [class.is-valid]="motherName.valid && motherName.touched"
              >
              @if ((motherName.invalid && motherName.touched) || (submitted && motherName.invalid)) {
                <div class="invalid-feedback">Mother's name is required (min 3 characters).</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Qualification</label>
              <input type="text" class="form-control" name="motherQualification" [(ngModel)]="mother.qualification" maxlength="80" placeholder="e.g. Post Graduate">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Occupation</label>
              <input type="text" class="form-control" name="motherOccupation" [(ngModel)]="mother.occupation" maxlength="80" placeholder="e.g. Teacher">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Mobile Number</label>
              <div class="input-group">
                <span class="input-group-text bg-light">+91</span>
                <input
                  type="tel"
                  class="form-control"
                  name="motherMobile"
                  [(ngModel)]="mother.mobile"
                  #motherMobile="ngModel"
                  pattern="^[6-9]\d{9}$"
                  maxlength="10"
                  placeholder="10-digit mobile"
                  [class.is-invalid]="motherMobile.invalid && motherMobile.touched"
                  [class.is-valid]="motherMobile.valid && motherMobile.touched && mother.mobile !== ''"
                >
              </div>
              @if (motherMobile.invalid && motherMobile.touched) {
                <div class="invalid-feedback d-block">Enter a valid 10-digit mobile number.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Email Address</label>
              <input
                type="email"
                class="form-control"
                name="motherEmail"
                [(ngModel)]="mother.email"
                #motherEmail="ngModel"
                email
                maxlength="100"
                placeholder="mother@email.com"
                [class.is-invalid]="motherEmail.invalid && motherEmail.touched"
                [class.is-valid]="motherEmail.valid && motherEmail.touched && mother.email !== ''"
              >
              @if (motherEmail.invalid && motherEmail.touched) {
                <div class="invalid-feedback">Enter a valid email address.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Annual Income (₹)</label>
              <input type="number" class="form-control" name="motherIncome" [(ngModel)]="mother.annualIncome" min="0" placeholder="e.g. 300000">
            </div>
          </div>

          <!-- Guardian -->
          <p class="sub-section-title"><i class="bi bi-shield-person"></i> Guardian Details <small class="text-muted fw-normal ms-2">(If applicable)</small></p>
          <div class="row g-3">
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Guardian's Full Name</label>
              <input type="text" class="form-control" name="guardianName" [(ngModel)]="guardian.name" maxlength="100" placeholder="Guardian's name">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Relation with Student</label>
              <input type="text" class="form-control" name="guardianRelation" [(ngModel)]="guardian.relation" maxlength="50" placeholder="e.g. Uncle, Grandparent">
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Mobile Number</label>
              <div class="input-group">
                <span class="input-group-text bg-light">+91</span>
                <input
                  type="tel"
                  class="form-control"
                  name="guardianMobile"
                  [(ngModel)]="guardian.mobile"
                  #guardianMobile="ngModel"
                  pattern="^[6-9]\d{9}$"
                  maxlength="10"
                  placeholder="10-digit mobile"
                  [class.is-invalid]="guardianMobile.invalid && guardianMobile.touched"
                >
              </div>
              @if (guardianMobile.invalid && guardianMobile.touched) {
                <div class="invalid-feedback d-block">Enter a valid 10-digit mobile number.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Email Address</label>
              <input type="email" class="form-control" name="guardianEmail" [(ngModel)]="guardian.email" email maxlength="100" placeholder="guardian@email.com">
            </div>
            <div class="col-md-8">
              <label class="form-label">Guardian's Address</label>
              <textarea class="form-control" name="guardianAddress" [(ngModel)]="guardian.address" rows="2" maxlength="300" placeholder="Full address of guardian"></textarea>
            </div>
          </div>

        </div>
      </div>

      <!-- ===================== C. ADDRESS ===================== -->
      <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-geo-alt-fill"></i>
          C. Address Details
        </div>
        <div class="card-body">

          <!-- Permanent Address -->
          <p class="sub-section-title"><i class="bi bi-house-fill"></i> Permanent Address</p>
          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-3">
              <label class="form-label">House / Flat No. <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="permHouseNo"
                [(ngModel)]="permanentAddress.houseNo"
                #permHouseNo="ngModel"
                required
                maxlength="50"
                placeholder="House / Flat No."
                [class.is-invalid]="(permHouseNo.invalid && permHouseNo.touched) || (submitted && permHouseNo.invalid)"
                [class.is-valid]="permHouseNo.valid && permHouseNo.touched"
              >
              @if ((permHouseNo.invalid && permHouseNo.touched) || (submitted && permHouseNo.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-5">
              <label class="form-label">Street / Locality <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="permStreet"
                [(ngModel)]="permanentAddress.street"
                #permStreet="ngModel"
                required
                maxlength="200"
                placeholder="Street, Colony, Locality"
                [class.is-invalid]="(permStreet.invalid && permStreet.touched) || (submitted && permStreet.invalid)"
                [class.is-valid]="permStreet.valid && permStreet.touched"
              >
              @if ((permStreet.invalid && permStreet.touched) || (submitted && permStreet.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">State <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="permState"
                [(ngModel)]="permanentAddress.state"
                #permState="ngModel"
                required
                [class.is-invalid]="(permState.invalid && permState.touched) || (submitted && permState.invalid)"
                [class.is-valid]="permState.valid && permState.touched"
                (change)="districts1 = dataService.getDist(permanentAddress.state)"
              >
                <option value="">-- Select State --</option>
                @for (s of stateOptions; track s) {
                  <option>{{ s.state }}</option>
                }
              </select>
              @if ((permState.invalid && permState.touched) || (submitted && permState.invalid)) {
                <div class="invalid-feedback">Please select state.</div>
              }
            </div>
            <!--<div class="col-md-6 col-lg-4">
              <label class="form-label">City <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="permCity"
                [(ngModel)]="permanentAddress.city"
                #permCity="ngModel"
                required
                maxlength="80"
                placeholder="City"
                [class.is-invalid]="(permCity.invalid && permCity.touched) || (submitted && permCity.invalid)"
                [class.is-valid]="permCity.valid && permCity.touched"
              >
              @if ((permCity.invalid && permCity.touched) || (submitted && permCity.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>-->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">City <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="permCity"
                [(ngModel)]="permanentAddress.city"
                #permCity="ngModel"
                required
                [class.is-invalid]="(permCity.invalid && permCity.touched) || (submitted && permCity.invalid)"
                [class.is-valid]="permCity.valid && permCity.touched"
              >
                <option value="">-- Select City --</option>
								@for(dist of districts1; track $index) {
								<option>{{dist}}</option>
								}
              </select>
              @if ((permCity.invalid && permCity.touched) || (submitted && permCity.invalid)) {
                <div class="invalid-feedback">Please select city.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">PIN Code <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="permPinCode"
                [(ngModel)]="permanentAddress.pinCode"
                #permPinCode="ngModel"
                required
                pattern="^\d{6}$"
                maxlength="6"
                placeholder="6-digit PIN"
                [class.is-invalid]="(permPinCode.invalid && permPinCode.touched) || (submitted && permPinCode.invalid)"
                [class.is-valid]="permPinCode.valid && permPinCode.touched"
              >
              @if ((permPinCode.invalid && permPinCode.touched) || (submitted && permPinCode.invalid)) {
                <div class="invalid-feedback">
                  @if (permPinCode.errors?.['required']) { PIN Code is required. }
                  @if (permPinCode.errors?.['pattern']) { Must be 6 digits. }
                </div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Country</label>
              <input type="text" class="form-control" name="permCountry" [(ngModel)]="permanentAddress.country" maxlength="50">
            </div>
          </div>

          <!-- Correspondence Address -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="sub-section-title mb-0"><i class="bi bi-envelope-fill"></i> Correspondence Address</p>
            <div class="form-check form-switch ms-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="sameAddress"
                name="sameAddress"
                [(ngModel)]="sameAsPermAddress"
                (change)="onSameAddressChange()"
              >
              <label class="form-check-label small" for="sameAddress">Same as Permanent Address</label>
            </div>
          </div>

          <div class="row g-3" [class.opacity-50]="sameAsPermAddress" [attr.aria-disabled]="sameAsPermAddress">
            <div class="col-md-6 col-lg-3">
              <label class="form-label">House / Flat No. <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="corrHouseNo"
                [(ngModel)]="correspondenceAddress.houseNo"
                #corrHouseNo="ngModel"
                required
                maxlength="50"
                [disabled]="sameAsPermAddress"
                placeholder="House / Flat No."
                [class.is-invalid]="(corrHouseNo.invalid && corrHouseNo.touched) || (submitted && corrHouseNo.invalid)"
                [class.is-valid]="corrHouseNo.valid && corrHouseNo.touched"
              >
              @if ((corrHouseNo.invalid && corrHouseNo.touched) || (submitted && corrHouseNo.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-5">
              <label class="form-label">Street / Locality <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="corrStreet"
                [(ngModel)]="correspondenceAddress.street"
                #corrStreet="ngModel"
                required
                maxlength="200"
                [disabled]="sameAsPermAddress"
                placeholder="Street, Colony, Locality"
                [class.is-invalid]="(corrStreet.invalid && corrStreet.touched) || (submitted && corrStreet.invalid)"
                [class.is-valid]="corrStreet.valid && corrStreet.touched"
              >
              @if ((corrStreet.invalid && corrStreet.touched) || (submitted && corrStreet.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">State <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="corrState"
                [(ngModel)]="correspondenceAddress.state"
                #corrState="ngModel"
                required
                [class.is-invalid]="(corrState.invalid && corrState.touched) || (submitted && corrState.invalid)"
                [class.is-valid]="corrState.valid && corrState.touched"
                (change)="districts2 = dataService.getDist(correspondenceAddress.state)"
              >
                <option value="">-- Select State --</option>
                @for (s of stateOptions; track s) {
                  <option>{{ s.state }}</option>
                }
              </select>
              @if ((corrState.invalid && corrState.touched) || (submitted && corrState.invalid)) {
                <div class="invalid-feedback">Please select state.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">City <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="corrCity"
                [(ngModel)]="correspondenceAddress.city"
                #corrCity="ngModel"
                required
                [class.is-invalid]="(corrCity.invalid && corrCity.touched) || (submitted && corrCity.invalid)"
                [class.is-valid]="corrCity.valid && corrCity.touched"
              >
                <option value="">-- Select City --</option>
								@for(dist of districts2; track $index) {
								<option>{{dist}}</option>
								}
              </select>
              @if ((corrCity.invalid && corrCity.touched) || (submitted && corrCity.invalid)) {
                <div class="invalid-feedback">Please select city.</div>
              }
            </div>
            <!-- <div class="col-md-6 col-lg-4">
              <label class="form-label">City <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="corrCity"
                [(ngModel)]="correspondenceAddress.city"
                #corrCity="ngModel"
                required
                maxlength="80"
                [disabled]="sameAsPermAddress"
                placeholder="City"
                [class.is-invalid]="(corrCity.invalid && corrCity.touched) || (submitted && corrCity.invalid)"
                [class.is-valid]="corrCity.valid && corrCity.touched"
              >
              @if ((corrCity.invalid && corrCity.touched) || (submitted && corrCity.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div> -->
            <!-- <div class="col-md-6 col-lg-4">
              <label class="form-label">State <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="corrState"
                [(ngModel)]="correspondenceAddress.state"
                #corrState="ngModel"
                required
                [disabled]="sameAsPermAddress"
                [class.is-invalid]="(corrState.invalid && corrState.touched) || (submitted && corrState.invalid)"
                [class.is-valid]="corrState.valid && corrState.touched"
              >
                <option value="">-- Select State --</option>
                @for (s of stateOptions; track s) {
                  <option [value]="s">{{ s }}</option>
                }
              </select>
              @if ((corrState.invalid && corrState.touched) || (submitted && corrState.invalid)) {
                <div class="invalid-feedback">Please select state.</div>
              }
            </div> -->
            <div class="col-md-6 col-lg-4">
              <label class="form-label">PIN Code <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="corrPinCode"
                [(ngModel)]="correspondenceAddress.pinCode"
                #corrPinCode="ngModel"
                required
                pattern="^\d{6}$"
                maxlength="6"
                [disabled]="sameAsPermAddress"
                placeholder="6-digit PIN"
                [class.is-invalid]="(corrPinCode.invalid && corrPinCode.touched) || (submitted && corrPinCode.invalid)"
                [class.is-valid]="corrPinCode.valid && corrPinCode.touched"
              >
              @if ((corrPinCode.invalid && corrPinCode.touched) || (submitted && corrPinCode.invalid)) {
                <div class="invalid-feedback">
                  @if (corrPinCode.errors?.['required']) { PIN Code is required. }
                  @if (corrPinCode.errors?.['pattern']) { Must be 6 digits. }
                </div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Country</label>
              <input type="text" class="form-control" name="corrCountry" [(ngModel)]="correspondenceAddress.country" [disabled]="sameAsPermAddress" maxlength="50">
            </div>
          </div>

        </div>
      </div>

      <!-- ===================== D. ACADEMIC DETAILS ===================== -->
      <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-journal-bookmark-fill"></i>
          D. Academic Details
        </div>
        <div class="card-body">

          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-5">
              <label class="form-label">Previous School / Institution <span class="required-star">*</span></label>
              <input
                type="text"
                class="form-control"
                name="previousSchool"
                [(ngModel)]="academics.previousSchool"
                #previousSchool="ngModel"
                required
                minlength="3"
                maxlength="200"
                placeholder="Name of previous school"
                [class.is-invalid]="(previousSchool.invalid && previousSchool.touched) || (submitted && previousSchool.invalid)"
                [class.is-valid]="previousSchool.valid && previousSchool.touched"
              >
              @if ((previousSchool.invalid && previousSchool.touched) || (submitted && previousSchool.invalid)) {
                <div class="invalid-feedback">Previous school name is required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-3">
              <label class="form-label">Board <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="board"
                [(ngModel)]="academics.board"
                #board="ngModel"
                required
                [class.is-invalid]="(board.invalid && board.touched) || (submitted && board.invalid)"
                [class.is-valid]="board.valid && board.touched"
              >
                <option value="">-- Select Board --</option>
                @for (b of boardOptions; track b) {
                  <option [value]="b.code">{{ b.code + ' - ' +b.name }}</option>
                }
              </select>
              @if ((board.invalid && board.touched) || (submitted && board.invalid)) {
                <div class="invalid-feedback">Please select board.</div>
              }
            </div>
            <div class="col-md-6 col-lg-2">
              <label class="form-label">Passing Year <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="passingYear"
                [(ngModel)]="academics.passingYear"
                #passingYear="ngModel"
                required
                [class.is-invalid]="(passingYear.invalid && passingYear.touched) || (submitted && passingYear.invalid)"
                [class.is-valid]="passingYear.valid && passingYear.touched"
              >
                <option value="">Year</option>
                @for (y of passingYears; track y) {
                  <option [value]="y">{{ y }}</option>
                }
              </select>
              @if ((passingYear.invalid && passingYear.touched) || (submitted && passingYear.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-2">
              <label class="form-label">Percentage / CGPA <span class="required-star">*</span></label>
              <input
                type="number"
                class="form-control"
                name="percentage"
                [(ngModel)]="academics.percentage"
                #percentage="ngModel"
                required
                min="0"
                max="100"
                step="0.01"
                placeholder="e.g. 85.5"
                [class.is-invalid]="(percentage.invalid && percentage.touched) || (submitted && percentage.invalid)"
                [class.is-valid]="percentage.valid && percentage.touched"
              >
              @if ((percentage.invalid && percentage.touched) || (submitted && percentage.invalid)) {
                <div class="invalid-feedback">
                  @if (percentage.errors?.['required']) { Required. }
                  @if (percentage.errors?.['min'] || percentage.errors?.['max']) { Must be 0–100. }
                </div>
              }
            </div>
            <!-- <div class="col-md-6 col-lg-4">
              <label class="form-label">TC / Migration Number</label>
              <input type="text" class="form-control" name="tcNumber" [(ngModel)]="academics.tcNumber" maxlength="50" placeholder="Transfer Certificate No.">
            </div> -->
          </div>

          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-4">
              <label class="form-label">New Class Name <span class="required-star">*</span></label>
              <select
                class="form-select"
                name="class_name"
                [(ngModel)]="academics.class_name"
                #class_name="ngModel"
                required
                [class.is-invalid]="(class_name.invalid && class_name.touched) || (submitted && class_name.invalid)"
                [class.is-valid]="class_name.valid && class_name.touched"
              >
                <option value="">--</option>
                @for (cls of dataService.classes; track cls) {
                  <option [value]="cls.code">{{ cls.name }}</option>
                }
              </select>
              @if ((class_name.invalid && class_name.touched) || (submitted && class_name.invalid)) {
                <div class="invalid-feedback">Required.</div>
              }
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">New Section</label>
              <select
                class="form-select"
                name="cls_section"
                [(ngModel)]="academics.cls_section"
                #cls_section="ngModel"
              >
                <option value="">--</option>
                @for (sec of dataService.sections; track sec) {
                  <option [value]="sec.code">{{ sec.name }}</option>
                }
              </select>
            </div>
            <div class="col-md-6 col-lg-4">
              <label class="form-label">Assign Roll No.</label>
              <input type="text" class="form-control" name="rollNumber" [(ngModel)]="academics.roll_no" maxlength="10" placeholder="Roll No.">
            </div>
          </div>

          <!-- Subjects and Marks -->
          <p class="sub-section-title"><i class="bi bi-list-ol"></i> Subjects and Marks</p>
          @for (subject of subjects; track subject; let i = $index) {
            <div class="subject-row">
              <div class="row g-2 align-items-center">
                <div class="col-auto fw-semibold text-muted" style="min-width: 30px;">{{ i + 1 }}.</div>
                <div class="col-md">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [name]="'subjectName' + i"
                    [(ngModel)]="subject.name"
                    placeholder="Subject name (e.g. Mathematics)"
                    maxlength="80"
                  >
                </div>
                <div class="col-md-3">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">Obtained</span>
                    <input
                      type="number"
                      class="form-control"
                      [name]="'marksObtained' + i"
                      [(ngModel)]="subject.marksObtained"
                      min="0"
                      [max]="subject.maxMarks ?? 100"
                      placeholder="e.g. 85"
                    >
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">Out of</span>
                    <input
                      type="number"
                      class="form-control"
                      [name]="'maxMarks' + i"
                      [(ngModel)]="subject.maxMarks"
                      min="1"
                      max="1000"
                      placeholder="100"
                    >
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn-remove"
                    (click)="removeSubject(i)"
                    [disabled]="subjects.length === 1"
                    title="Remove subject"
                  >
                    <i class="bi bi-x-lg" style="font-size: 0.75rem;"></i>
                  </button>
                </div>
              </div>
            </div>
          }
          <button type="button" class="btn btn-add-subject mt-2" (click)="addSubject()">
            <i class="bi bi-plus-circle me-1"></i> Add Subject
          </button>

        </div>
      </div>

      <!-- ===================== E. ADDITIONAL INFORMATION ===================== -->
      <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-info-circle-fill"></i>
          E. Additional Information
        </div>
        <div class="card-body">
          <div class="row g-3">

            <!-- Transport -->
            <div class="col-md-6 col-lg-3">
              <label class="form-label d-block">Transport Required?</label>
              <div class="d-flex gap-3 mt-1">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="transport" id="transportYes" [value]="true" [(ngModel)]="additional.transportRequired">
                  <label class="form-check-label" for="transportYes">Yes</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="transport" id="transportNo" [value]="false" [(ngModel)]="additional.transportRequired">
                  <label class="form-check-label" for="transportNo">No</label>
                </div>
              </div>
            </div>

            <!-- Hostel -->
            <div class="col-md-6 col-lg-3">
              <label class="form-label d-block">Hostel Required?</label>
              <div class="d-flex gap-3 mt-1">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="hostel" id="hostelYes" [value]="true" [(ngModel)]="additional.hostelRequired">
                  <label class="form-check-label" for="hostelYes">Yes</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="hostel" id="hostelNo" [value]="false" [(ngModel)]="additional.hostelRequired">
                  <label class="form-check-label" for="hostelNo">No</label>
                </div>
              </div>
            </div>

            <!-- Scholarship Category -->
            <div class="col-md-6 col-lg-3">
              <label class="form-label">Scholarship Category</label>
              <select class="form-select" name="scholarshipCategory" [(ngModel)]="additional.scholarshipCategory">
                <option value="">-- Select --</option>
                @for (sc of scholarshipOptions; track sc) {
                  <option [value]="sc">{{ sc }}</option>
                }
              </select>
            </div>

            <!-- Sports Category -->
            <div class="col-md-6 col-lg-3">
              <label class="form-label">Sports Category</label>
              <select class="form-select" name="sportsCategory" [(ngModel)]="additional.sportsCategory">
                <option value="">-- Select --</option>
                @for (sp of sportsOptions; track sp) {
                  <option [value]="sp">{{ sp }}</option>
                }
              </select>
            </div>

            <!-- Medical Condition -->
            <div class="col-12">
              <label class="form-label">Any Medical Condition / Disability</label>
              <textarea
                class="form-control"
                name="medicalCondition"
                [(ngModel)]="additional.medicalCondition"
                rows="2"
                maxlength="500"
                placeholder="Describe any medical condition, allergy, or disability if applicable..."
              ></textarea>
              <div class="form-text">{{ additional && additional?.medicalCondition?.length }}/500 characters</div>
            </div>

          </div>
        </div>
      </div>

      <!-- ===================== F. DOCUMENTS ===================== -->
      <div class="section-card card" *ngIf="editID>0">
        <div class="section-header">
          <i class="bi bi-file-earmark-arrow-up-fill"></i>
          F. Document Upload
          <span class="ms-auto badge-section">PDF / JPG / PNG — Max 2MB each</span>
        </div>
        <div class="card-body">
          <div class="row g-3">
            @for (doc of documents; track doc.name) {
              <div class="col-md-6 col-lg-4">
                <label class="form-label">{{ doc.label }}</label>
                <label class="file-upload-area d-block" [for]="'file-' + doc.name">
                  @if (!doc.fileName) {
                    <div>
                      <i class="bi bi-cloud-upload d-block mb-1"></i>
                      <p class="mb-0">Click to upload</p>
                      <p class="text-muted" style="font-size: 0.75rem;">PDF, JPG, PNG (max 2MB)</p>
                    </div>
                  } @else {
                    <div>
                      <i class="bi bi-file-check d-block mb-1" style="color: #28a745;"></i>
                      <p class="file-name mb-0">{{ doc.fileName }}</p>
                      <p class="text-success" style="font-size: 0.75rem;">Uploaded</p>
                    </div>
                  }
                  <input
                    type="file"
                    [id]="'file-' + doc.name"
                    [name]="'file-' + doc.name"
                    class="d-none"
                    accept=".pdf,.jpg,.jpeg,.png"
                    (change)="onFileSelect($event, doc)"
                  >
                </label>
              </div>
            }
          </div>
          <div class="alert alert-info mt-3 d-flex align-items-start gap-2 p-3" role="alert">
            <i class="bi bi-info-circle-fill mt-1"></i>
            <div class="small">
              <strong>Note:</strong> Ensure all documents are clear, legible scans or photographs. Blurry or incomplete documents may result in application rejection.
              Original documents must be produced at the time of admission for verification.
            </div>
          </div>
        </div>
      </div>

      <!-- ===================== DECLARATION ===================== -->
      <!-- <div class="section-card card">
        <div class="section-header">
          <i class="bi bi-pen-fill"></i>
          Declaration
        </div>
        <div class="card-body">
          <div class="declaration-box">
            <p class="fw-semibold text-dark mb-3" style="font-size: 0.95rem;">
              <i class="bi bi-quote fs-4 text-warning me-1"></i>
              Declaration by Parent / Guardian
            </p>
            <p class="text-secondary" style="font-size: 0.9rem; line-height: 1.8;">
              I/We hereby declare that the information furnished in this application form is true, complete, and correct to the best of my/our knowledge and belief.
              I/We understand that any false or misleading information will render the application invalid and may result in cancellation of admission.
              I/We agree to abide by the rules, regulations, and code of conduct of the institution. I/We consent to the collection and processing of the personal
              data provided herein for the purpose of admission and student records management, in accordance with applicable data protection laws.
            </p>
            <hr class="my-3">
            <div class="row g-3 align-items-start">
              <div class="col-md-4">
                <label class="form-label">Place <span class="required-star">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  name="declarationPlace"
                  [(ngModel)]="declaration.place"
                  #declarationPlace="ngModel"
                  required
                  maxlength="100"
                  placeholder="City where signing"
                  [class.is-invalid]="(declarationPlace.invalid && declarationPlace.touched) || (submitted && declarationPlace.invalid)"
                  [class.is-valid]="declarationPlace.valid && declarationPlace.touched"
                >
                @if ((declarationPlace.invalid && declarationPlace.touched) || (submitted && declarationPlace.invalid)) {
                  <div class="invalid-feedback">Place is required.</div>
                }
              </div>
              <div class="col-md-4">
                <label class="form-label">Date <span class="required-star">*</span></label>
                <input
                  type="date"
                  class="form-control"
                  name="declarationDate"
                  [(ngModel)]="declaration.date"
                  #declarationDate="ngModel"
                  required
                  [class.is-invalid]="(declarationDate.invalid && declarationDate.touched) || (submitted && declarationDate.invalid)"
                  [class.is-valid]="declarationDate.valid && declarationDate.touched"
                >
                @if ((declarationDate.invalid && declarationDate.touched) || (submitted && declarationDate.invalid)) {
                  <div class="invalid-feedback">Date is required.</div>
                }
              </div>
              <div class="col-12 mt-3">
                <div
                  class="form-check"
                  [class.is-invalid]="submitted && !declaration.accepted"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="declarationAccepted"
                    name="declarationAccepted"
                    [(ngModel)]="declaration.accepted"
                    [class.is-invalid]="submitted && !declaration.accepted"
                  >
                  <label class="form-check-label fw-semibold" for="declarationAccepted" style="font-size: 0.9rem;">
                    I / We have read and accept the above declaration. I / We understand and agree to all the terms and conditions of the institution.
                    <span class="required-star">*</span>
                  </label>
                </div>
                @if (submitted && !declaration.accepted) {
                  <div class="text-danger mt-1" style="font-size: 0.8rem;">
                    <i class="bi bi-exclamation-circle me-1"></i>You must accept the declaration to proceed.
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- ===================== SUBMIT SECTION ===================== -->
      <div class="form-card">
        <div class="submit-section">
          @if (submitted && appForm.invalid) {
            <div class="alert alert-danger d-flex align-items-center gap-2 mb-4 text-start" role="alert">
              <i class="bi bi-exclamation-triangle-fill fs-5"></i>
              <div>
                <strong>Please correct the errors above.</strong> All required fields must be filled before submitting.
              </div>
            </div>
          }
          <!-- @if (submitted && !declaration.accepted) {
            <div class="alert alert-warning d-flex align-items-center gap-2 mb-4 text-start" role="alert">
              <i class="bi bi-info-circle-fill fs-5"></i>
              <div>Please accept the declaration at the bottom of the form to submit.</div>
            </div>
          } -->
          <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <button type="submit" class="btn btn-submit" [disabled]="submitSuccess">
              @if (submitSuccess) {
                <span class="spinner-border spinner-border-sm me-2" role="status"></span> Submitting...
              } @else {
                <i class="bi bi-send-fill me-2"></i> Submit Application
              }
            </button>
            <button type="button" class="btn btn-reset" (click)="onReset(appForm)">
              <i class="bi bi-arrow-counterclockwise me-2"></i> Reset Form
            </button>
          </div>
          <!-- <p class="text-muted small mt-3 mb-0">
            <i class="bi bi-lock-fill me-1"></i>
            Your information is secure and will only be used for admission purposes.
          </p> -->
        </div>
      </div>

    </form>
  </div>
</div>
